/// <reference path="../../app.ts" />

namespace Advant.Crossroads {
    "use strict";

    interface ICollegeConnectApplicationsReport {
        log: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;
        logSuccess: (msg, data?, showHowl?) => void;
        loadingUserApplications: boolean;
        userApplications: Array<IUserApplicationViewModel>;
        applicationDefinition: IApplicationDefinition;
        rules: Array<IRuleSet>;
        page: number;
        pageSize: number;
        sortBy: string;
        searchFilter: string;
        sortDirection: string;
        totalCount: number;
        totalPages: number;
        startRow: number;
        endRow: number;
        dataPath: string;
        chartPath: string;
        dateLabel: string;
        showNewOnlyFilter: boolean;
        dateStart: string;
        dateEnd: string;
        newOnly: boolean;
        ruleIdFilter: string;
        showFilter: boolean;
        filter: any;
        chartConfig: any;

        activate: () => void;
        searchApplications: () => void;
        sort: (sortValue: string) => void;
    }

    class CollegeConnectApplicationsReport implements ICollegeConnectApplicationsReport {
        log: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;
        logSuccess: (msg, data?, showHowl?) => void;
        loadingUserApplications: boolean;
        userApplications: any;
        applicationDefinition: IApplicationDefinition;
        rules: Array<IRuleSet>;
        page: number;
        pageSize: number;
        sortBy: string;
        searchFilter: string;
        sortDirection: string;
        totalCount: number;
        totalPages: number;
        startRow: number;
        termCode: string;
        endRow: number;
        dataPath: string = "userApplications";
        chartPath: string;
        dateLabel: string;
        showNewOnlyFilter: boolean;
        dateStart: string;
        dateEnd: string;
        newOnly: boolean;
        ruleIdFilter: string;
        showFilter: boolean;
        exporting: boolean = false;
        filter: any;
        chartConfig: any;
        showGraph: boolean = false;
        currentAppId: string = "";
        currentAppName: string = "";
        minDate: any;
        dateOptions: any;

        static $inject: any = ["$scope", "$location", "$http", "Restangular", "dialogs", "common", "config", "helper"];

        constructor(public $scope: IUserApplicationsScope,
            public $location: angular.ILocationService,
            public $http: angular.IHttpService,
            public Restangular: Restangular.IService,
            public dialogs: angular.dialogs.IDialogService,
            public common: ICommonService,
            public config: ICrossroadsConfig,
            private helper: IHelper) {

            this.log = common.logger.getLogFn("collegeConnectApplicationsReport");
            this.logError = common.logger.getLogFn("collegeConnectApplicationsReport", "error");
            this.logSuccess = common.logger.getLogFn("collegeConnectApplicationsReport", "success");

            this.dataPath = "userApplications/collegeConnect";
            this.chartPath = "userApplications/collegeConnectByApplication";
            this.dateLabel = "Submitted Between";
            this.showNewOnlyFilter = true;

            this.page = 1;
            this.pageSize = 25;
            this.sortBy = "Name";
            this.sortDirection = "ASC";
            this.searchFilter = "";
            this.showFilter = false;
            this.dateStart = null;
            this.dateEnd = null;
            this.minDate = new Date(2024, 8, 1);
            this.dateOptions = {
                minDate: this.minDate
            };

            this.loadingUserApplications = false;

            this.chartConfig = {
                "chart": {
                    "type": "areaspline"
                },
                "plotOptions": {
                    "series": {
                        "stacking": ""
                    }
                },
                "series": [
                    {
                        "name": "Applications Submitted",
                        "data": [],
                        "id": "series-0",
                        "connectNulls": true,
                        "type": "areaspline",
                        "color": "#0E81B2"
                    },
                    {
                        "name": "Unique Users",
                        "data": [],
                        "connectNulls": true,
                        "id": "series-1",
                        "type": "areaspline",
                        "color": "#f0ad4e"
                    }
                ],
                title: {
                    "text": "Applications Submitted"
                },
                credits: {
                    "enabled": false
                },
                "loading": false,
                xAxis: {
                    title: "Date",
                    categories: [
                        "04/13", "04/14", "04/15", "04/16", "04/17", "04/18",
                        "04/19"
                    ]
                },
                yAxis: {
                    title: "Applications"
                }
            };

            $scope.$on(config.events.applicationChanged, (event) => {
                this.activate();
            });

            this.activate();
        }

        activate = () => {
            this.common.activateController([this.getApplications(), this.getApplicationDefinition(), this.getRules()], "collegeConnectApplicationsReport")
                .then(result => {
                    this.log("Activated UserApplications View");
                });
        };

        clearFilter = () => {
            this.dateStart = null;
            this.dateEnd = null;
            this.getApplications();
        };

        exportToExcel = () => {
            this.exporting = true;
            var queryParams = this.getQueryParams();
            var httpPath = this.config.apiHost + "/" + this.common.getUser().activeApplication +
                "/userApplications/collegeConnect/export?startDate=" + queryParams.startDate + "&endDate=" + queryParams.endDate + "&sortBy=" + encodeURI(queryParams.sortBy) + "&sortDirection=" + queryParams.sortDirection;

            this.helper.openFile(httpPath).then(() => {
                this.exporting = false;
            }, (reason) => {
                this.logError("An error occurred while saving the report to excel", reason);
            });
        }

        getApplications(){
            this.loadingUserApplications = true;
            this.Restangular.one(this.common.getUser().activeApplication + "/" + this.dataPath).get(this.getQueryParams()).then((result) => {
                this.userApplications = result;
                this.loadingUserApplications = false;
                if (this.currentAppId != "")
                    this.loadChart(this.currentAppId,this.currentAppName);
                return result;
            }, (reason) => {
                this.loadingUserApplications = false;
                this.logError("An error occurred while getting the user applications", reason);
            });
        };

        getApplicationDefinition = (): angular.IPromise<IApplicationDefinition> => {
            return this.Restangular
                .one(this.common.getUser().activeApplication).get()
                .then((result) => {
                    this.applicationDefinition = result;

                    return result;
                }, (error) => {
                    this.logError("An error occurred while attempting to retrieve the application information.", error);
                });
        };

        getRules = (): angular.IPromise<Array<IRuleSet>> => {
            this.rules = [];
            return this.Restangular.one(this.common.getUser().activeApplication).all("rules").getList().then((result) => {
                this.rules = result;
                this.rules.unshift({ id: null, name: "" });
                return result;
            }, (reason) => {
                this.logError("An error occurred while getting the rules", reason);
                return this.rules;
            });
        };

        getQueryParams = (): any => {
            var queryParams = {
                startDate: this.dateStart ? moment(this.dateStart).toISOString() : null,
                endDate: this.dateEnd ? moment(this.dateEnd).toISOString() : null,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection,

            };

            return queryParams;
        };

        searchApplications = (): void => {
            this.common.debouncedThrottle("UserApplicationSearch", () => { this.page = 1; this.getApplications(); }, 400);
        };

        sort = (sortValue: string): void => {
            if (this.sortBy === sortValue) {
                this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
            } else {
                this.sortBy = sortValue;
            }
            this.page = 1;
            this.getApplications();
        };

        loadChart = (appId: any, name: any): any => {
            this.currentAppId = appId;
            this.currentAppName = name;
            this.chartConfig.xAxis.categories = [];
            this.chartConfig.series[0].data = [];
            this.chartConfig.series[1].data = [];
            this.chartConfig.title.text = name;
            var queryParams = {
                applicationDefinitionId: appId,
                startDate: this.dateStart ? this.dateStart : null,
                endDate: this.dateEnd ? this.dateEnd : null
            };
            this.Restangular.one(this.common.getUser().activeApplication + "/" + this.chartPath).get(queryParams).then((result) => {
                result.forEach(item => {
                    this.chartConfig.xAxis.categories.push(item.date);
                    this.chartConfig.series[0].data.push(item.total);
                    this.chartConfig.series[1].data.push(item.users);
                });
                this.showGraph = true;
            }, (reason) => {
                this.loadingUserApplications = false;
                this.logError("An error occurred while getting the user applications", reason);
            });
        };
    }

    angular.module("app").controller("collegeConnectApplicationsReport", CollegeConnectApplicationsReport);
}